import type { Hit } from 'instantsearch.js/es/types';
import type { CentPrecisionMoney } from '../codegen/types';

export type StringsPerLocale = {
  [key: string]: string;
};

export type SearchResultType = Hit<{
  colour: StringsPerLocale;
  description: StringsPerLocale;
  fit: string[];
  image: string;
  key: string;
  name: StringsPerLocale;
  objectID: string;
  productType: StringsPerLocale;
  size: string[];
  price: CentPrecisionMoney;
  wasPrice?: CentPrecisionMoney;
  thenPrice?: CentPrecisionMoney;
  // TODO when actual data is finalized
  [dynamicKey: string]: unknown;
}>;

export enum FacetNames {
  SIZE = 'size',
  FIT = 'width',
  HEEL_HEIGHT = 'heel height',
  GENDER = 'gender',
  COLOR = 'color',
  PRODUCT = 'product type',
  STYLE = 'style name',
  FASTENING = 'fastening ',
  TECHNOLOGY = 'technology',
  TOP_RATED = 'top rated',
  BRAND = 'brand',
  MATERIAL = 'material',
  PRICE = 'price',
}
